
    <!-- [class]="options?.htmlClass || ''"-->
    <div [class.floatLabelContainer]="true">
      <label *ngIf="options?.title"
        [attr.for]="'control' + layoutNode?._id"
        [class]="options?.labelHtmlClass || ''"
        [style.display]="options?.notitle ? 'none' : ''"
        [innerHTML]="options?.title"></label>
      <input float-label
        [dropSpecialCharacters]="false" [mask]="options?.maskFormat"
        [formControl]="formControl"
        [attr.aria-describedby]="'control' + layoutNode?._id + 'Status'"
        [attr.list]="'control' + layoutNode?._id + 'Autocomplete'"
        [attr.maxlength]="options?.maxLength"
        [attr.minlength]="options?.minLength"
        [attr.pattern]="options?.pattern"
        [attr.placeholder]="options?.placeholder"
        [attr.required]="options?.required"
        [class]="options?.fieldHtmlClass || ''"
        [disabled]="controlDisabled"
        [id]="'control' + layoutNode?._id"
        [name]="controlName"
        [readonly]="options?.readonly ? 'readonly' : null"
        [type]="layoutNode?.type"
        [value]="controlValue"
        (input)="updateValue($event)"
        (blur)="validateInputValue($event)"
        (keydown)="onChange()"
        (paste)="onChange()"
        (keypress)="onChange();validationInProgress($event);removeError();"
        (keyup)="removeError()" (paste)="validationInProgress($event)">
        <span *ngIf="options?.hint" class="fa fa-question-circle-o mr-2 personal-info--bonus-info"
        [outsideClick]="true" containerClass="personal-info--bonus-info__popover" placement ="top"
            [popover]="controlName==schemaPropertyEnum.VATID ? hintTemplateVatId : hintTemplate" >
        </span>
        <ng-template #hintTemplateVatId>
          {{options?.hint}}
        </ng-template>
        <ng-template #hintTemplate>
            {{'allowed format(s) '}} <br> {{options?.hint}}
        </ng-template>
        <datalist *ngIf="options?.typeahead?.source"
          [id]="'control' + layoutNode?._id + 'Autocomplete'">
          <option *ngFor="let word of options?.typeahead?.source" [value]="word">
        </datalist>
        <!-- Email verification spinner block start -->
        <span *ngIf="layoutNode?.name==='email' && isShowLoader" tabindex="0" class="personal-info--email-info">
        <i class="fa fa-spinner"></i></span>
        <!-- Email verification spinner block end -->
        <!-- Government Id verification spinner block start -->
        <span *ngIf="layoutNode?.name==='vatId' && isShowVATIdLoader" tabindex="0" class="personal-info--email-info">
        <i class="fa fa-spinner"></i></span>
        <!-- Government Id verification spinner block end -->
    </div>
    <span *ngIf="customMessage" [class]="'error custom-error'">{{customMessage}}</span>


// WEBPACK FOOTER //
// ./src/app/customerservice/widgets/custom-mask-textbox.widget.ts.CustomMaskTextboxComponent.html